// src/components/services/Table/ServicesTableRow.jsx
import React from "react";
import { TableRow, TableCell, IconButton, Checkbox, Chip, Avatar } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import MiscellaneousServicesIcon from "@mui/icons-material/MiscellaneousServices";

const ServicesTableRow = ({
    service,
    index,
    isDark,
    page,
    perPage,
    sortBy,
    sortDir,
    totalItems,
    selectedIds,
    onRowCheckboxClick,
    onMenuOpen,
    isArchive = false,
    menuDisabled = false
}) => {
    const serial =
        sortDir === "asc"
            ? (page - 1) * perPage + index + 1
            : (page - 1) * perPage + (totalItems - index);

    const isOdd = index % 2 === 0;
    const isSelected = selectedIds.includes(service?.id);
    const imageUrl = service?.image?.url || service?.image?.preview || null;

    return (
        <TableRow
            hover
            sx={{
                backgroundColor: isOdd
                    ? isDark
                        ? "rgba(55,65,81,0.45)"
                        : "rgba(249,250,251,0.9)"
                    : "transparent",
            }}
        >
            <TableCell padding="checkbox">
                <Checkbox
                    color="primary"
                    checked={isSelected}
                    onClick={(e) => onRowCheckboxClick(e, service?.id)}
                    inputProps={{ "aria-labelledby": `service-${service?.id}` }}
                />
            </TableCell>

            <TableCell>{serial}</TableCell>
            <TableCell>
                <Avatar
                    src={imageUrl}
                    alt={service?.name?.en || "Service"}
                    sx={{
                        width: 48,
                        height: 48,
                        borderRadius: 1,
                        bgcolor: isDark ? "rgba(59,130,246,0.2)" : "rgba(59,130,246,0.1)",
                    }}
                >
                    {!imageUrl && <MiscellaneousServicesIcon />}
                </Avatar>
            </TableCell>
            <TableCell sx={{ color: isDark ? "#E5E7EB" : "#1F2937" }}>
                {service?.name?.ar || "-"}
            </TableCell>

            <TableCell sx={{ color: isDark ? "#E5E7EB" : "#1F2937" }}>
                {service?.name?.en || "-"}
            </TableCell>

            <TableCell>
                <Chip
                    label={service?.status ? "Active" : "Inactive"}
                    color={service?.status ? "success" : "default"}
                    size="small"
                    sx={{
                        fontSize: "0.75rem",
                        fontWeight: 500,
                    }}
                />
            </TableCell>

            <TableCell align="right">
                <IconButton
                    size="small"
                    disabled={menuDisabled}
                    onClick={(e) => {
                        e.stopPropagation();
                        onMenuOpen(e, service);
                    }}
                    sx={{ color: isDark ? "#E5E7EB" : "#1F2937" }}
                >
                    <MoreVertIcon fontSize="small" />
                </IconButton>
            </TableCell>
        </TableRow>
    );
};

export default ServicesTableRow;
